import AxiosService from "./AxiosService";

let FournisseurService = {
  getProduits() {
    return AxiosService.get("api/fournisseurs/me/produits");
  },
  getProduitsPublies() {
    return AxiosService.get("api/fournisseurs/me/produits/publies");
  },
  getProduitsPourCsv() {
    return AxiosService.get(`api/fournisseurs/me/produits/export`);
  },
  getFichesDM(ids) {
    let idsText = ids.map((v) => `ids=${v}`).join("&");
    return AxiosService.get("api/fournisseurs/me/fichesDM?" + idsText, {
      responseType: "arraybuffer",
    });
  },
  getAccountInfo() {
    return AxiosService.get("api/fournisseurs/me");
  },
  getLogoImage(file) {
    return AxiosService.get(`${process.env.VUE_APP_CHEMIN_LOGOS_FRNS}${file}`);
  },
  savePassword(infos) {
    return AxiosService.put("api/fournisseurs/me/changePassword", infos);
  },
  getDemandes(options = {}) {
    let { page, perPage, id, etat, idProduit } = options;
    let baseUrl = "api/fournisseurs/me/demandes";
    // console.log("etat", etat);
    // console.log("page", page);
    // console.log("perPage", perPage);
    // console.log("id", id);
    // console.log("idProduit", idProduit);
    if (page == undefined) {
      page = 1;
    }
    if (perPage == undefined) {
      perPage = 10;
    }
    if (id != undefined) {
      return AxiosService.get(`${baseUrl}?id=${id}`);
    } else if (idProduit != undefined) {
      return AxiosService.get(
        `${baseUrl}?produit=${idProduit}&pageIndex=${page}&itemsPerPage=${perPage}`
      );
    }
    if (etat == undefined) {
      return AxiosService.get(
        `${baseUrl}?pageIndex=${page}&itemsPerPage=${perPage}`
      );
    } else {
      return AxiosService.get(
        `${baseUrl}?etat=${etat}&pageIndex=${page}&itemsPerPage=${perPage}`
      );
    }
  },
  getDemandesIds() {
    return AxiosService.get(`api/fournisseurs/me/demandes/ids`);
  },
  getProduitsDemandes() {
    return AxiosService.get(`api/fournisseurs/me/demandes/produits`);
  },
  getEtatsDemandes() {
    return AxiosService.get(`api/demandes/etats`);
  },
  deleteDemande(id) {
    return AxiosService.delete(`api/fournisseurs/me/demandes/${id}`);
  },
  getDemande(id) {
    return AxiosService.get(`api/fournisseurs/me/demandes/${id}`);
  },
  getProduitDemande(idDemande) {
    return AxiosService.get(`api/demandes/${idDemande}/produit`);
  },
  update(payload) {
    return AxiosService.put(`api/fournisseurs/me`, payload);
  },
  updateLogo(file) {
    let data = new FormData();
    //data.append("name", "files");
    data.append("files", file);
    let config = {
      header: {
        "Content-Type": "multipart/form-data",
      },
    };

    return AxiosService.put(`api/fournisseurs/me/logo`, data, config);
  },
  deleteLogo() {
    return AxiosService.delete(`api/fournisseurs/me/logo`);
  },
  getIndications(q) {
    if (q) {
      return AxiosService.get(`api/indications?q=${q}`);
    }
    return AxiosService.get(`api/indications`);
  },
  getDomaines(options) {
    let { q, all } = options;
    if (q) {
      return AxiosService.get(`api/domaines?q=${q}`);
    } else if (all) {
      return AxiosService.get(`api/domaines?all=true`);
    }
    return AxiosService.get(`api/domaines`);
  },
  getDomainesDeno(idDeno) {
    return AxiosService.get(`api/denominations-communes/${idDeno}/domaines`);
  },
  getSubstances(options) {
    let { q, all } = options;
    if (q) {
      return AxiosService.get(`api/substances?q=${q}`);
    } else if (all) {
      return AxiosService.get(`api/substances?all=true`);
    }
    return AxiosService.get(`api/substances`);
  },
  getSterilisations(options) {
    let { q, all } = options;
    if (q) {
      return AxiosService.get(`api/sterilisations?q=${q}`);
    } else if (all) {
      return AxiosService.get(`api/sterilisations?all=true`);
    }
    return AxiosService.get(`api/sterilisations`);
  },
  getMateriaux(options) {
    let { q, all } = options;
    if (q) {
      return AxiosService.get(`api/materiaux?q=${q}`);
    } else if (all) {
      return AxiosService.get(`api/materiaux?all=true`);
    }
    return AxiosService.get(`api/materiaux`);
  },
  getElements(options) {
    let { q, all } = options;
    if (q) {
      return AxiosService.get(`api/elements?q=${q}`);
    } else if (all) {
      return AxiosService.get(`api/elements?all=true`);
    }
    return AxiosService.get(`api/elements`);
  },
  getConditionnements(options) {
    let { q, all } = options;
    if (q) {
      return AxiosService.get(`api/conditionnements?q=${q}`);
    } else if (all) {
      return AxiosService.get(`api/conditionnements?all=true`);
    }
    return AxiosService.get(`api/conditionnements`);
  },
  getCaracteristiques(options) {
    let { q, all } = options;
    if (q) {
      return AxiosService.get(`api/caracteristiques?q=${q}`);
    } else if (all) {
      return AxiosService.get(`api/caracteristiques?all=true`);
    }
    return AxiosService.get(`api/caracteristiques`);
  },
  getDenominations(options) {
    let { all } = options;
    if (all) {
      return AxiosService.get(`api/denominations-communes/all`);
    } else {
      return null;
    }
  },
  getDenominationsPourProduit(options) {
    let { q } = options;
    //console.log(q);
    //if (q) {
    return AxiosService.get(`api/denominations-communes/pourProduit?q=${q}`);
    //}
    // return AxiosService.get(`api/denominations-communes/pourProduit`);
  },
  addDemande(payload) {
    return AxiosService.post(`api/fournisseurs/me/demandes`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  updateDemande(id, payload) {
    return AxiosService.put(`api/fournisseurs/me/demandes/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getConditionnement(id) {
    return AxiosService.get(`api/conditionnements/${id}`);
  },
  sendDemandeToPharmat(id) {
    return AxiosService.put(`api/fournisseurs/me/demandes/${id}/transmettre`);
  },
  getProduitFournisseur(id) {
    return AxiosService.get(`api/produits/${id}`);
  },
  getFournisseurPourApercu(id) {
    return AxiosService.get(`api/fournisseurs/publies/${id}`);
  },
};

export default FournisseurService;
